import React from 'react';
import { BaseNewsletter } from './BaseNewsletter';
import { createClient } from '@/prismicio';

interface PopularBlogGridProps {
  children?: React.ReactNode;
}

export const PopularBlogGrid = async ({ children }: PopularBlogGridProps) => {
  const client = createClient();
  const settings = await client.getSingle('settings');

  return (
    <div className="w-full text-white">
      <h2 className="text-xl md:text-2xl font-bold mb-10">Popular posts</h2>
      <div id="grid-container" className="w-full">
        <div
          className="grid grid-cols-1 md:grid-cols-3 gap-10"
          style={{
            gridAutoRows: 'minmax(0,auto)',
            gridTemplateColumns: 'repeat(3, minmax(0,1fr))',
          }}
        >
          {children}
          <div data-newsletter>
            <BaseNewsletter
              button_label="Subscribe"
              disclaimer=""
              email_placeholder="Enter your email"
              formId={`${settings.data.default_newsletter_form_id}`}
              hubspotPortalIdForm={`${settings.data.hubspotPortalIdForm}`}
              invite_text=""
              title="Stay up to date on features and releases"
              variation="blog-home-grid"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
